import { IStatus } from './statuses';

export enum CollaborationDocumentReviewStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  Closed = 4,
}

export const CollaborateReviewStatuses: IStatus<CollaborationDocumentReviewStatus>[] = [
  {
    text: CollaborationDocumentReviewStatus[CollaborationDocumentReviewStatus.Pending],
    value: CollaborationDocumentReviewStatus.Pending,
  },
  {
    text: CollaborationDocumentReviewStatus[CollaborationDocumentReviewStatus.InProgress],
    value: CollaborationDocumentReviewStatus.InProgress,
  },
  {
    text: CollaborationDocumentReviewStatus[CollaborationDocumentReviewStatus.Completed],
    value: CollaborationDocumentReviewStatus.Completed,
  },
];
